export const changes = [
    'Nomination sans départ',
    'Départ sans remplacement',
    'Départ avec remplacement'
]